<template>
	<div class="flex-box">
		<div class="search-box">
			<div v-if="$hasPermission('A20101')">
				<label style="width: auto;" class="searchItemName">渠道：</label>
				<el-select v-model="SelectChannelId" clearable placeholder="筛选渠道">
					<el-option v-for="item in options" :key="item.id" :label="item.channelName" :value="item.id">
					</el-option>
				</el-select>
			</div>
			<div>
				<label class="searchItemName">筛选日期：</label>
				<el-date-picker v-model="dateRange" type="daterange" align="right" unlink-panels range-separator="至"
					start-placeholder="开始日期" end-placeholder="结束日期" :picker-options="pickerOptions">
				</el-date-picker>
			</div>
			<el-button style="margin-left: 10px;" type="primary" v-on:click="GetData()" icon="el-icon-search">查询</el-button>
			<el-button style="margin-left: 10px;" type="primary" v-on:click="ExportTable()"
				icon="el-icon-download">下载统计数据信息</el-button>
		</div>
		<!--数据表格-->
		<div>
			<el-table :data="tableData" border style="width: 100%;margin: 15px 0px;">
				<el-table-column prop="channelName" label="渠道" width="auto" min-width="110" align="center">
				</el-table-column>
				<el-table-column prop="examineCount" label="体检次数" width="auto" min-width="160" align="center">
				</el-table-column>
				<el-table-column prop="photoCount" label="拍照次数" width="auto" min-width="120" align="center">
				</el-table-column>
				<el-table-column prop="examinePhotoCount" label="体检+拍照次数" width="auto" min-width="100" align="center">
				</el-table-column>
				<el-table-column prop="credentPhotoCount" label="证件照次数" width="auto" min-width="120" align="center">
				</el-table-column>
				<el-table-column prop="healthPhotoCount" label="健康证相片次数" width="auto" min-width="120" align="center">
				</el-table-column>
				<el-table-column prop="driverExamFormCount" label="驾驶人体检表次数" width="auto" min-width="120" align="center">
				</el-table-column>
				<el-table-column prop="healthApplyFormCount" label="健康证申请表次数" width="auto" min-width="120" align="center">
				</el-table-column>
				<el-table-column prop="practitionerListCount" label="从业名单次数" width="auto" min-width="110" align="center">
				</el-table-column>
				<el-table-column prop="examineAmountTotal" label="体检总金额" width="auto" min-width="100" align="center">
					<template slot-scope="scope">
						{{scope.row.examineAmountTotal/100}}元
					</template>
				</el-table-column>
				<el-table-column prop="photoAmountTotal" label="拍照总金额" width="auto" min-width="100" align="center">
					<template slot-scope="scope">
						{{scope.row.photoAmountTotal/100}}元
					</template>
				</el-table-column>
				<el-table-column prop="examinePhotoAmountTotal" label="体检+拍照总金额" width="auto" min-width="100" align="center">
					<template slot-scope="scope">
						{{scope.row.examinePhotoAmountTotal/100}}元
					</template>
				</el-table-column>
				<el-table-column prop="credentPhotoAmountTotal" label="证件照总金额" width="auto" min-width="100" align="center">
					<template slot-scope="scope">
						{{scope.row.credentPhotoAmountTotal/100}}元
					</template>
				</el-table-column>
				<el-table-column prop="healthPhotoAmountTotal" label="健康证相片总金额" width="auto" min-width="120" align="center">
					<template slot-scope="scope">
						{{(scope.row.healthPhotoAmountTotal||0)/100}}元
					</template>
				</el-table-column>
				<el-table-column prop="driverExamFormAmountTotal" label="体检表总金额" width="auto" min-width="110" align="center">
					<template slot-scope="scope">
						{{(scope.row.driverExamFormAmountTotal||0)/100}}元
					</template>
				</el-table-column>
				<el-table-column prop="healthApplyFormAmountTotal" label="申请表总金额" width="auto" min-width="110" align="center">
					<template slot-scope="scope">
						{{(scope.row.healthApplyFormAmountTotal||0)/100}}元
					</template>
				</el-table-column>
				<el-table-column prop="practitionerListAmountTotal" label="从业名单总金额" width="auto" min-width="120" align="center">
					<template slot-scope="scope">
						{{(scope.row.practitionerListAmountTotal||0)/100}}元
					</template>
				</el-table-column>
				<el-table-column prop="refundTotal" label="退款总金额" width="auto" min-width="100" align="center">
					<template slot-scope="scope">
						{{scope.row.refundTotal/100}}元
					</template>
				</el-table-column>
			</el-table>
		</div>
		<!-- <div>
			<el-pagination background @size-change="handleSizeChange" @current-change="handleCurrentChange"
				:current-page.sync="queryParams.pageIndex" :page-sizes="[10, 20, 30, 40, 50]"
				:page-size="queryParams.pageSize" layout="sizes, prev, pager, next" :total="total">
			</el-pagination>
		</div> -->
	</div>
</template>

<script>
	import Excel from '../../../../public/tools/exportExcelHelp.js';
	import {
		post
	} from '../../../../public/request/request.js';
	export default {
		data() {
			return {
				/**
				 * 数据总条数
				 */
				total: 0,
				/**
				 * 接口查询参数
				 */
				queryParams: {
					/**
					 * 当前页码
					 */
					pageIndex: 1,
					/**
					 * 每页条数
					 */
					pageSize: 10,
					/**
					 * 渠道
					 */
					channelId: 0,
					/**
					 * 开始日期
					 */
					beginTime: '',
					/**
					 * 结束日期
					 */
					endTime: '',
				},
				/**
				 * 渠道下拉框
				 */
				options: [],
				/**
				 * 数据表格
				 */
				tableData: [],
				/**
				 * 新增数据model
				 */
				form: {},
				/**
				 * el-dialog 参数
				 */
				dialogFormVisible: false,
				dialogTitle: '',
				dialogOperationType: '',
				/**
				 * 日期框快捷选项
				 */
				pickerOptions: {
					shortcuts: [{
						text: '最近一周',
						onClick(picker) {
							const end = new Date();
							const start = new Date();
							start.setTime(start.getTime() - 3600 * 1000 * 24 * 7);
							picker.$emit('pick', [start, end]);
						}
					}, {
						text: '最近一个月',
						onClick(picker) {
							const end = new Date();
							const start = new Date();
							start.setTime(start.getTime() - 3600 * 1000 * 24 * 30);
							picker.$emit('pick', [start, end]);
						}
					}, {
						text: '最近三个月',
						onClick(picker) {
							const end = new Date();
							const start = new Date();
							start.setTime(start.getTime() - 3600 * 1000 * 24 * 90);
							picker.$emit('pick', [start, end]);
						}
					}]
				},
			}
		},
		/**
		 * 方法
		 */
		methods: {
			/**
			 * 获取数据列表
			 */
			GetData() {
				const loading = this.openLoading();
				// 获取时间段统计
				post('601', this.queryParams)
					.then(response => {
						if (response.data.result == 0) {
							this.tableData = response.data.data;
							loading.close();
						} else {
							this.$message.error('查询数据失败:' + response.data.message);
						}
					})
					.catch(error => {
						this.$message.error((error && error.userMessage) || '查询数据失败');
					});
			},
			/**
			 * 导出记录表
			 */
			ExportTable(){
				const data = this.tableData.map(item => {
					return {
						'渠道': item.channelName,
						'体检次数': item.examineCount,
						'拍照次数': item.photoCount,
						'体检+拍照次数': item.examinePhotoCount,
						'证件照次数': item.credentPhotoCount,
						'健康证相片次数': item.healthPhotoCount || 0,
						'驾驶人体检表次数': item.driverExamFormCount || 0,
						'健康证申请表次数': item.healthApplyFormCount || 0,
						'从业名单次数': item.practitionerListCount || 0,
						'体检总金额': item.examineAmountTotal / 100,
						'拍照总金额': item.photoAmountTotal / 100,
						'体检+拍照总金额': item.examinePhotoAmountTotal / 100,
						'证件照总金额': item.credentPhotoAmountTotal / 100,
						'健康证相片总金额': (item.healthPhotoAmountTotal || 0) / 100,
						'体检表总金额': (item.driverExamFormAmountTotal || 0) / 100,
						'申请表总金额': (item.healthApplyFormAmountTotal || 0) / 100,
						'从业名单总金额': (item.practitionerListAmountTotal || 0) / 100,
						'退款总金额': item.refundTotal / 100
					};
				});
				Excel.ExportExcel(data);
			},
			/**
			 * 获取渠道数据
			 */
			GetChannelData() {
				// 检查是否允许获取渠道数据
				const allowChannel = sessionStorage.getItem('allowChannel');
				if (allowChannel === 'false') {
					return; // 不允许获取渠道，直接返回
				}
				// 获取渠道数据列表
				post('208', {
						channelName: ''
					})
					.then(response => {
						if (response.data.result == 0) {
							this.options = response.data.data;
						} else {
							this.$message.error('获取渠道失败:' + response.data.message);
						}
					})
					.catch(error => {
						this.$message.error((error && error.userMessage) || '获取渠道失败');
					});
			},
			/**
			 * 页码切换事件
			 */
			handleCurrentChange(pageIndex) {
				this.GetData();
			},
			/**
			 * 每页大小切换事件
			 */
			handleSizeChange(size) {
				this.queryParams.pageSize = size;
			},
			/**
			 * 日期转yyyy-MM-dd
			 * @param {Object} today日期
			 */
			dataToString(today) {
				let year = today.getFullYear();
				let month = (today.getMonth() + 1).toString().padStart(2, '0');
				let day = today.getDate().toString().padStart(2, '0');
				return `${year}-${month}-${day}`;
			},
			/**
			 * 日期转HH:mm:ss
			 * @param {Object} today日期
			 */
			dataToString2(today) {
				let timeString = today.toLocaleTimeString('it-IT');
				return timeString;
			},
			/**
			 * 打开加载遮罩
			 */
			openLoading() {
				const loading = this.$loading({
					lock: true,
					text: 'Loading',
					spinner: 'el-icon-loading',
					background: 'rgba(0, 0, 0, 0.4)'
				});
				return loading;
			},
		},
		/**
		 * 加载完成事件
		 */
		mounted() {
			this.GetChannelData();
			this.GetData();
		},
		/**
		 * 计算属性
		 */
		computed: {
			/**
			 * 日期范围选择框
			 */
			dateRange: {
				get() {
					if (this.queryParams.beginTime == "" || this.queryParams.endTime == "") {
						const today = new Date();
						// 获取上个月的第一天，避免天数不一致的问题（与 detail.vue 一致）
						const lastMonth = new Date(today.getFullYear(), today.getMonth() - 1, 1);
						this.queryParams.beginTime = this.dataToString(lastMonth);
						this.queryParams.endTime = this.dataToString(today);
					}
					return [new Date(Date.parse(this.queryParams.beginTime)), new Date(Date.parse(this.queryParams
						.endTime))];
				},
				set(value) {
					if (value == null) {
						const today = new Date();
						const lastMonth = new Date(today.getFullYear(), today.getMonth() - 1, 1);
						this.queryParams.beginTime = this.dataToString(lastMonth);
						this.queryParams.endTime = this.dataToString(today);
					} else {
						this.queryParams.beginTime = this.dataToString(value[0]);
						this.queryParams.endTime = this.dataToString(value[1]);
					}
				}
			},
			/**
			 * 选择的渠道id
			 */
			SelectChannelId: {
				get() {
					if (this.queryParams.channelId == 0) {
						return '';
					} else {
						return this.queryParams.channelId;
					}
				},
				set(value) {
					if (value == '') {
						this.queryParams.channelId = 0;
					} else {
						this.queryParams.channelId = value;
					}
				}
			}
		}
	}
</script>

<style>
	.flex-box {
		display: flex;
		flex-direction: column;
	}

	.search-box {
		display: flex;
		flex-direction: row;
		flex-wrap: wrap;
		align-items: center;
	}

	.searchItemName {
		width: 100px;
		text-align: right;
		display: inline-block;
	}

	.input-box {
		width: 200px;
	}

	.from-input {
		width: 300px;
	}
</style>